window.addEventListener('load', function() {
  function updateDisclosures() {
    // Select all disclosure elements
    const filterDisclosures = document.querySelectorAll('.disclosure');
    
    filterDisclosures.forEach(disclosure => {
      const filterList = disclosure.querySelector('ul'); // Find the <ul> inside the disclosure
      
      if (filterList) {
        const listItems = filterList.querySelectorAll('li:not(.js-hidden)'); // Only consider non-hidden <li> items
        
        // If there are no visible <li> items, hide the disclosure
        if (listItems.length === 0) {
          disclosure.style.display = 'none'; // Hide disclosure if no filterable items
        } else {
          disclosure.style.display = 'block'; // Show disclosure if filterable items exist
        }
      }
    });
  }
  
  // Run the function initially
  updateDisclosures();
  
  // Observe changes in the DOM for dynamically added content
  const observer = new MutationObserver(() => {
    updateDisclosures();
  });

  // Start observing the body for changes
  observer.observe(document.body, { childList: true, subtree: true });
});
